module.exports = __webpack_public_path__ + "img/ss.670f5cca.png";